// frontend/src/types/codeEditor.types.ts

export interface CodeEvaluationScores {
  quality: number; // 0-10
  logic: number; // 0-10
  readability: number; // 0-10
}

export interface CodeEvaluationResult {
  scores: CodeEvaluationScores;
  improvements: string[];
  overallFeedback: string;
}

export const DEFAULT_STARTER_CODE = `# Merhaba! Buraya kodunu yaz
# For döngüsü örneği:

for i in range(5):
    print(f"Merhaba Dünya! {i+1}. kez")

# Liste örneği:
meyveler = ["elma", "armut", "muz"]
for meyve in meyveler:
    print(meyve)

# Fonksiyon örneği:
def selamla(isim):
    return f"Merhaba, {isim}!"

print(selamla("Erdem"))
`;
